/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type GenerationLogListStatus =
  (typeof GenerationLogListStatus)[keyof typeof GenerationLogListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerationLogListStatus = {
  completed: "completed",
  failed: "failed",
  in_progress: "in_progress",
  pending: "pending",
} as const;
